import styled from '@emotion/styled';
import { Button } from '../../layouts';

export const TripTypeSelectorButton = styled(Button)`
    &&& {
        justify-content: center;
        flex: 1 1 0px;
        z-index: 0;
        margin: 0;
        height: auto;
        white-space: normal;
        transition: all 0s ease 0s;
    }
`;
